import { ParameterValue } from './';

export class ParameterInfo {
    public name: string = '';
    public type: string = '';
    public text: string = '';
    public multivalue: boolean = false;
    public allowNull: boolean = false;
    public allowBlank: boolean = false;
    public isVisible: boolean = false;
    public autoRefresh: boolean = false;
    public hasChildParameters: boolean = false;
    public childParameters: ParameterInfo[] = [];
    public availableValues: ParameterValue[] = [];
    public value: any = '';
    public id: string = '';
    public label: string = '';
}
